var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 10,
    viewBox: "0 0 36 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4249 5.35355C30.6201 5.15829 30.6201 4.84171 30.4249 4.64644L27.2429 1.46446C27.0476 1.2692 26.731 1.2692 26.5358 1.46446C26.3405 1.65973 26.3405 1.97631 26.5358 2.17157L29.3642 5L26.5358 7.82843C26.3405 8.02369 26.3405 8.34027 26.5358 8.53553C26.731 8.73079 27.0476 8.73079 27.2429 8.53553L30.4249 5.35355ZM5.92871 5.5L30.0713 5.5L30.0713 4.5L5.92871 4.5L5.92871 5.5Z",
    fill: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f3e53181b530302918c1bb759579502f.svg";
export { ForwardRef as ReactComponent };